<!-- Header -->
<h1 mat-dialog-title>
  Paragraaf toevoegen
  <!-- <span class="button-group">
    <button mat-button tabindex="-1" (click)="submit()">
      {{ 'restoreTemplateValue' | translate }}
    </button>
  </span> -->
</h1>

<!-- Content -->
<div mat-dialog-content>
  
  <div class="dialog-wrapper" fxLayout="row">

    <div fxFlex>
      <form [formGroup]="form">

        <!-- Element type: new / template -->
        <mat-form-field appearance="standard">
          <mat-label>Element-type</mat-label>
          <mat-select formControlName="elementType">
            <mat-option *ngFor="let elementType of elementTypes" [value]="elementType._id">
              {{ elementType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Template type: project / building -->
        <mat-form-field appearance="standard">
          <mat-label>Template-type</mat-label>
          <mat-select formControlName="templateType">
            <mat-option *ngFor="let templateType of templateTypes" [value]="templateType._id">
              {{ templateType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Template name -->
        <mat-form-field appearance="standard">
          <mat-label>Template</mat-label>
          <mat-select formControlName="template">
            <mat-option *ngFor="let template of templates" [value]="template.name">
              {{ template.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
        <!-- Template name -->
        <mat-form-field appearance="standard">
          <mat-label>Kwaliteitsniveau</mat-label>
          <mat-select formControlName="qualityLevel">
            <mat-option *ngFor="let qualityLevel of qualityLevels" [value]="qualityLevel._id">
              {{ qualityLevel.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </form>
    </div>

    <!-- Module tree -->
    <div class="module-tree" fxFlex>
      <ul class="modules">
        <ng-container *ngFor="let module of tree">
          <li *ngIf="module.active">
            <strong>{{ module.name }}</strong>

            <ul class="submodules">
              <ng-container *ngFor="let submodule of module.submodules">
                <li *ngIf="submodule.active">
                  <strong>{{ submodule.name }}</strong>

                  <ul class="elements">
                    <ng-container *ngFor="let element of submodule.elements">
                      <li class="a"
                      *ngIf="element.active"
                      [class.active]="element._id === selectedElement?._id" 
                      [id]="element._id"
                      (click)="selectElement(element)">
                        {{ element.name }}
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>

    <!-- Preview -->
    <!-- Use the quality level form value to preview the current template variant. -->
    <div class="preview" fxFlex>
      <span [innerHtml]="selectedElement?.values[form.get('qualityLevel').value - 1]?.value | safeHtml"></span>
    </div>

  </div>

</div>

<!-- Actions -->
<div mat-dialog-actions align="end">
  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'" [disabled]="!formValid">
    {{ 'add' | translate }}
  </button>
</div>
